import React, { FC } from 'react';
import { SystemIcon } from '@monorepo/nova-icons';
import { BannerCloseButton } from '../styled';
import { BannerCloseButtonProps } from '../types';

export const BannerCloseButtonComponent: FC<BannerCloseButtonProps> = ({
  onClose,
}) => {
  return (
    <BannerCloseButton onClick={onClose} aria-label="Close banner">
      <SystemIcon iconName="Close" size={20} />
    </BannerCloseButton>
  );
};
